import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  background: transparent;
`;
